const emailRegEx = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+(?:[a-zA-Z]{2,})\b$/i;
const POTENTIAL_ZIPCODE = /(^|\s+)[0-9]{5}/;

/**
 * Returns true of the given value is a valid full name
 * @param value
 * @returns {boolean|boolean}
 */
export const isValidFullName = value => {
  const names = String(value || '').split(/\s+/);
  const lastName = names.pop();
  const firstName = names.join(' ');
  return !!firstName && !!lastName;
};

/**
 * Returns true if the provided value is considered a valid phone number
 * @param value
 * @returns {boolean|boolean}
 */
export const isValidPhone = (value: number | string = ''): boolean => {
  const parsedVal = String(value || '').replace(/\D/g, '');
  return parsedVal.length === 10 || (parsedVal.length === 11 && parsedVal.charAt(0) === '1');
};

/**
 * Returns true if the provided value is considered a valid email address
 * @param value
 * @returns {*|boolean}
 */
export const isValidEmail = (value: string): boolean => (
  !!value && value.length > 0 && !!value.match(emailRegEx)
);

/**
 * Returns true if the provided value is considered a valid birthdate entry
 * @param value
 * @returns {*|boolean}
 */
export const isValidBirthday = (value: string): boolean => (
  /^(0[1-9]|1[012])[/](0[1-9]|[12][0-9]|3[01])$/.test(value)
);

/**
 * Returns true if the provided value is considered a valid zip code
 * @param value
 * @returns {*|boolean}
 */
export const isValidZipcode = (value: string): boolean => POTENTIAL_ZIPCODE.test(value);

/**
 * Returns true if the provided value is considered a valid steet address
 * @param value
 * @returns {*|boolean}
 */
export const isValidStreetAddress = (value: string): boolean => /^\d+\s(\d+|\D+)+$/.test(value);

/**
 * Returns true if the provided value can be parsed to a URL and starts with http or https
 */
export const isValidUrl = (value: string): boolean => {
  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
};
